interface SectionHeaderProps {
  eyebrow: string;
  title: React.ReactNode;
  description?: string;
  align?: 'left' | 'center';
  right?: React.ReactNode;
}

export default function SectionHeader({ eyebrow, title, description, align = 'left', right }: SectionHeaderProps) {
  return (
    <div className={`mb-8 flex flex-col gap-4 md:mb-12 ${align === 'center' ? 'items-center text-center' : 'items-start'} ${right ? 'md:flex-row md:items-end md:justify-between' : ''}`}>
      <div className={right ? 'md:max-w-xl' : ''}>
        <span className="rp-mono-mini text-rp-moss">{eyebrow}</span>
        <h2 className="rp-section-h2 mt-3 text-rp-ink">{title}</h2>
        {description && <p className={`mt-3 text-sm leading-relaxed text-rp-moss ${align === 'center' ? 'max-w-xl' : 'max-w-md'}`}>{description}</p>}
      </div>
      {right && <div className="shrink-0">{right}</div>}
    </div>
  );
}
